import {useQuery} from '@apollo/react-hooks';

import type {GetOnboardingChecklist as GetOnboardingChecklistQuery} from 'nutshell-graphql-types';

import GET_ONBOARDING_CHECKLIST from '../queries/get-onboarding-checklist.graphql';

export const useGetOnboardingChecklist = () => {
    const {
        data,
        loading: isLoading,
        refetch,
    } = useQuery<GetOnboardingChecklistQuery, Record<any, any>>(GET_ONBOARDING_CHECKLIST, {
        fetchPolicy: 'cache-and-network',
    });

    const onboardingChecklist = data ? data.onboardingChecklist : null;
    const completedCount = onboardingChecklist
        ? onboardingChecklist.items.filter((item) => item.isComplete).length
        : undefined;
    const totalCount = onboardingChecklist ? onboardingChecklist.items.length : undefined;
    const checklistIsComplete = totalCount && completedCount === totalCount;

    return {
        onboardingChecklist,
        completedCount,
        totalCount,
        checklistIsComplete,
        isLoading,
        refetch,
    };
};
